import type { GridRowId } from "@mui/x-data-grid-pro";
import type { CustomFunctionUiActionView } from "src/api/generated/io/aavo/applications/db/erp/types/customFunctionUiActionView.ts";

export function resolveCustomUiActionObjectId<RowData extends object>(
	row: RowData,
	getRowId: (row: RowData) => GridRowId,
	getObjectId?: (row: RowData) => number | null,
): number | null {
	if (getObjectId != null) return getObjectId(row);

	const rowId = getRowId(row);
	if (typeof rowId !== "number") {
		throw new Error("UI actions require a numeric object ID selector for this data grid.");
	}
	return rowId;
}

export function resolveCustomUiActionObjectIds<RowData extends object>(
	rows: RowData[],
	getRowId: (row: RowData) => GridRowId,
	getObjectId?: (row: RowData) => number | null,
): number[] | null {
	const objectIds = rows
		.map((row) => resolveCustomUiActionObjectId(row, getRowId, getObjectId))
		.filter((objectId) => objectId != null);
	return objectIds.length > 0 ? objectIds : null;
}

export function resolveCustomUiActionObjectIdsForView<RowData extends object>(
	view: CustomFunctionUiActionView | undefined,
	rows: RowData[],
	getRowId: (row: RowData) => GridRowId,
	getObjectId?: (row: RowData) => number | null,
): number[] | null {
	if (view == null) return null;
	return resolveCustomUiActionObjectIds(rows, getRowId, getObjectId);
}
